import { type ParsedElicitation } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/elicitation';

/** Tool calls blocked on a consent dock, keyed by the wire `toolCallId`. */
export const getPendingToolCallIdsFromElicitations = (pendingElicitations: ParsedElicitation[]): Set<string> => {
  const pendingToolCallIds = new Set<string>();

  for (const entry of pendingElicitations) {
    if (entry.kind !== 'tool_consent') {
      continue;
    }

    pendingToolCallIds.add(entry.elicitation.payload.toolCallId);
  }

  return pendingToolCallIds;
};
